import React from 'react';
import { useTranslation } from 'react-i18next';
import type { LoaderProps } from '@components/atoms/loader/types';
import { Typography } from '@components/atoms/typography';
import { styled } from 'styled-components';

import { LoaderIcon } from '../../icons';

import { LoaderContainer } from './styles';

const Atom: React.FC<LoaderProps> = (props) => {
    const { t } = useTranslation();
    const { text = t('common.loading') } = props;

    return (
        <LoaderContainer className={props.className}>
            <div className='loader-container'>
                <LoaderIcon className='loader' />
            </div>
            {text && (
                <Typography variant='small-text' color='text-light' tag='span' className='text'>
                    {text}
                </Typography>
            )}
        </LoaderContainer>
    );
};

export const Loader = styled(Atom)({});
